var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo"},[_c('router-link',{attrs:{"to":{name:'dashboard'}}},[(_vm.showTitle)?_c('h1',{staticClass:"header-title"},[_vm._v(_vm._s(_vm.VUE_APP_PLATFORM_NAME))]):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }